<template>
  <div class="container">
    <div class="d-flex align-items-center my-5" v-if="loading">
      <div class="spinner-border text-danger" role="status"></div>
      <div class="ms-3">
        <strong>Loading...</strong>
      </div>
    </div>
    <div v-if="!loading">
      <template v-if="state == 'new'">
        <div class="d-flex align-items-center my-5">
          <button
            type="button"
            class="btn btn-warning mb-3 btn-lg"
            @click="startScanning"
          >
            Start scanning</button
          >
        </div>
      </template>
      <template v-if="state == 'scan'">
        <div class="d-flex align-items-center my-5">
          <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
        </div>
      </template>
      <template v-if="state == 'result'">
        <div class="container">
          <div class="col-12 my-4">
            <div class="alert" :class="alertColor" role="alert">
              <h2>
                <strong>{{ scanResult?.length }}</strong> ticket
                <template v-if="alertColor == 'alert-danger'"> - Already checked in</template>
              </h2>
            </div>
          </div>
          <div class="col-12 my-4">
            <button
              type="button"
              class="btn btn-warning mb-3 btn-lg"
              @click="confirmScan"
              v-if="alertColor == 'alert-success'"
            >
              Confirm
            </button>&nbsp;
            <button
              type="button"
              class="btn btn-light mb-3 btn-lg"
              @click="cancelScan"
            >
              Cancel
            </button>
          </div>
          <div class="col-12 mb-5">
            Participant list:<br/>
            <template v-for="customer in scanResult" :key="customer.SK">
              <div class="border px-2 py-2 mb-2">
                <div class="d-flex flex-row align-items-center">
                  <div class="flex-grow-1">
                    <strong>{{ customer.Name }}</strong>&nbsp;
                    <template v-if="customer.PaymentStatus != 'paid'">
                      <span class="badge bg-danger">{{
                        customer.PaymentStatus
                      }}</span>
                    </template>
                    <template v-if="customer.PaymentStatus == 'paid'">
                      <span class="badge bg-info">{{
                        customer.PaymentStatus
                      }}</span></template
                    ><br />
                    {{ customer.MobileNumber }}
                    <br />
                  </div>
                  <div>
                    <button type="button" class="btn btn-warning" @click="getBaziChart(customer)">Get Bazi Chart PDF</button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import { DateTime } from "luxon";
//import * as _ from "lodash";
import { API } from "aws-amplify";
import { QrcodeStream } from "qrcode-reader-vue3";

export default {
  name: "Home",
  components: {
    QrcodeStream,
  },
  data: () => ({
    loading: false,
    showScanner: true,
    state: "new",
    scanResult: null,
  }),
  computed: {
    alertColor() {
      if (this.scanResult?.length > 0) {
        if (this.scanResult[0]?.EventCheckIn == 'yes') {
          return 'alert-danger'
        } else {
          return 'alert-success'
        }
      } else {
        return '';
      }
    }
  },
  mounted() {},
  watch: {},
  methods: {
    async onDecode(result) {
      this.scanResult = result;
      this.loading = true;

      this.scanResult = await API.get("attendance", "/getByQR", {
        queryStringParameters: {
          EventOrderId: result,
        },
      });

      this.loading = false;
      this.state = "result";
    },

    onInit(promise) {
      promise.then(console.log).catch((e) => {
        alert(e);
        this.state = "new";
      });
    },

    startScanning() {
      this.state = "scan";
    },

    cancelScan() {
      this.scanResult = null;
      this.state = "new";
    },

    async confirmScan() {
      this.loading = true;
      try {
        const apiResult = await API.post("attendance", "/updateRegistration", {
          body: this.scanResult
        })
        alert(apiResult)
      } catch (e) {
        alert("Error - attendance not recorded")
      } finally {
        this.loading = false;
        this.scanResult = null;
        this.state = "new";
      }
    },

    async getBaziChart(customer) {
      try {
        const s3key = await API.get("attendance", "/getCustomerBaziChart", {
          queryStringParameters: customer
        })
        if (!s3key) throw new Error()

        const signedLink = await API.get("links", "/baziDirectAccess", {
          queryStringParameters: {
            key: s3key.S3ObjectKey
          }
        })

        window.open(signedLink, '_blank');
      } catch (e) {
        alert("Error - unable to get bazi chart")
      }
    }
  },
};
</script>

<style scoped>
@media (max-width: 991.98px) {
  .custom-mobile-text {
    font-size: 0.9rem;
  }
  .page-header {
    margin-top: -8px;
  }
}

.services-container {
  color: #939597;
}
.services-container h5.card-title {
  color: #75787b;
}
.services-container h5.card-title-blue {
  color: #003a70;
}
.services-container h5.date {
  color: #939597;
  font-size: 0.85rem;
}
.services-container .card-text {
  font-size: 0.8rem;
}
.services-container h5 {
  font-size: 1.1rem;
}
</style>
